var h = Object.defineProperty;
var n = (s, e, t) => e in s ? h(s, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : s[e] = t;
var o = (s, e, t) => n(s, typeof e != "symbol" ? e + "" : e, t);
import { EditableEntity as r, EventBroker as l } from "@zdrbm/zdr-native-tools";
class u extends r {
  constructor(t, i) {
    super(void 0);
    o(this, "highlightedItems");
    o(this, "autoFocus");
    o(this, "onItemAction");
    this.highlightedItems = this.createPropEventBroker("highlightedItems", t), this.autoFocus = this.createPropEventBroker("autoFocus", i), this.onItemAction = new l(this);
  }
  invokeItemSelected(t, i) {
    this.onItemAction.emit({ item: t, e: i });
  }
  setAutofocus(t) {
    this.autoFocus.set(t);
  }
  getItemsLength() {
    return this.highlightedItems.get().length;
  }
  getItemByIndex(t) {
    return this.highlightedItems.get()[t];
  }
  setItems(t) {
    this.highlightedItems.set(t);
  }
  getEntityName() {
    return "MultiSelectDropdownMenuState";
  }
}
export {
  u as MultiSelectDropdownMenuState
};
//# sourceMappingURL=index.es5613.js.map
